// client/src/components/ContactUs/ContactUs.js
import React from 'react';
import './ContactUs.css';

const ContactUs = () => {
  // --- Replace the entire return block ---
  
  return (
    <section id="contact" className="section contact-section">
      <div className="contact-content">
        <h2>Contact Us</h2>
        <p>Get in touch with the Om Nidhi Production team.</p>
        <div className="contact-info">
          {/* --- UPDATED DETAILS --- */}
          <p>
            <strong>Address:</strong> 1st floor, Narayana, BEML Layout,
            Brookefield, Bengaluru, Karnataka 560066
          </p>
          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:omnidhiproduction@gmail.com" className="contact-link">
              omnidhiproduction@gmail.com
            </a>
          </p>
          <p>
            <strong>Phone:</strong>{' '}
            <a href="tel:+91 95352 91453" className="contact-link">
              +91 95352 91453
            </a>
          </p>
        </div>
        <div className="contact-socials">
          {/* --- UPDATED LINKS --- */}
          <a
            href="https://www.facebook.com/omnidhi.productions"
            target="_blank"
            rel="noopener noreferrer"
          >
            Facebook
          </a>
          <a
            href="https://www.instagram.com/omnidhi.productions"
            target="_blank"
            rel="noopener noreferrer"
          >
            Instagram
          </a>
          {/* Add YouTube link if you have one, e.g.: */}
          {/* <a href="YOUR_YOUTUBE_LINK" target="_blank" rel="noopener noreferrer">YouTube</a> */}
        </div>
      </div>

      <div className="footer-bottom">
        <a href="#hero" className="back-to-top-link">
          ^ Back to Top
        </a>
        <p className="footer-copyright">
          © {new Date().getFullYear()} Om Nidhi Productions. All Rights Reserved.
        </p>
      </div>
    </section>
  );
};

export default ContactUs;